export enum ReportUserStatusEnum {
  Active = 0,
  Suspended = 1,
}

export const reportUserStatusNames = {
  [ReportUserStatusEnum.Active]: 'Active',
  [ReportUserStatusEnum.Suspended]: 'Suspended',
};

export const reportUserStatuses = [
  {
    label: reportUserStatusNames[ReportUserStatusEnum.Active],
    value: ReportUserStatusEnum.Active,
  },
  {
    label: reportUserStatusNames[ReportUserStatusEnum.Suspended],
    value: ReportUserStatusEnum.Suspended,
  },
];
